import React, { useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import assets from "../../../Assets";
import "./styles.scss";

const DatePicker = (props) => {
  const {
    image = true,
    border = false,
    selected,
    placeholderText,
    onChange,
    format,
    disabled = false,
    maxDate = null,
    minDate = null,
    isTimer = false,
    width,
    height,
    radius,
  } = props;
  const calendarRef = useRef(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleClick = () => {
    if (calendarRef.current) {
      calendarRef.current.setOpen(true);
    }
  };

  return (
    <div
      className="date-picker-container"
      style={{
        border: `${border ? isFocused ? '2.5px solid black' : '1px solid #B2BEC3' : ''}`,
        width: `${width || ''}`,
        height: `${height || ''}`,
        borderRadius: `${radius || ''}`,
      }}
    >
      <ReactDatePicker
        selected={selected}
        disabled={disabled}
        maxDate={maxDate}
        showTimeSelectOnly={isTimer}
        showTimeSelect={isTimer}
        minDate={minDate}
        dropdownMode="select"
        className={`date-picker-input ${disabled && "disabledInput"}`}
        placeholderText={placeholderText}
        dateFormat={format}
        onChange={onChange}
        ref={calendarRef}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <div
        className="calendar-icon-container"
        onClick={() => handleClick()}
      >
        {image ? (
          <img
            className={`calendar-icon`}
            src={assets.Icons.calendar}
            alt="calender"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default DatePicker;